import { call, debounce, put, select, takeLatest } from 'redux-saga/effects';

import { IUpdateUserPersonalDetails, UserActionTypes } from './types/actions';
import getWhoAmIRequest from './crud/getWhoami';
import {
  getWhoAmIError,
  getWhoAmIStarted,
  getWhoAmISuccess,
  setCompanyPreferences,
  setUnreadCounts,
  setUserData,
  updateUserError,
  updateUserStarted,
  updateUserSuccess,
} from './actions';
import updateUserPersonalDetails from './crud/updateUser';
import { sessionTimeValid } from 'App/utils/sessionTimer';
import getCustomer from 'Admin/crud/getCustomer';
import { getCloudProviders } from 'Location/CloudConnect/CloudProviders/hooks'

export function* getWhoAmISaga(): any {
  if (!sessionTimeValid()) {
    yield put(getWhoAmIError());
    return;
  }

  try {
    yield put(getWhoAmIStarted());

    const user = yield call(getWhoAmIRequest);

    yield put(setUserData(user.data));
    yield put(getWhoAmISuccess());
  } catch (error) {
    yield put(getWhoAmIError());
  }
}

export function* updateUnreadCountsSaga(): any {
  if (!sessionTimeValid()) {
    yield put(getWhoAmIError());
    return;
  }

  const user = yield call(getWhoAmIRequest);

  yield put(setUnreadCounts(user.data));
}

export function* updateUserSaga({ payload }: IUpdateUserPersonalDetails): any {
  yield put(updateUserStarted());

  try {
    const updatedUser = yield call(updateUserPersonalDetails, payload);
    yield put(setUserData(updatedUser.data));

    yield put(updateUserSuccess());
  } catch (error) {
    yield put(updateUserError());
  }
}

function* checkCustomerChangeThenFetchCompanyPreferencesSaga(action: any): any {
  try {
    // Select current customerPreferences from state
    // Only fetch if the company id is different
    const existingCustomerPreferences = yield select((state) => state.user.customerPreferences);
    if (!existingCustomerPreferences || existingCustomerPreferences.id !== action.payload.id) {
      yield call(fetchCompanyPreferencesSaga, action);
    }
  } catch (error) {
    // Optionally handle error
  }
}

function* fetchCompanyPreferencesSaga(action: any): any {
  try {

    // Fetch both customer preferences and cloud providers in parallel
    const newCustomerPreferences = yield call(getCustomer, action.payload.id);
    const newCloudProviders = yield call(getCloudProviders, action.payload.id);

    // Update state with new preferences and cloud providers
    yield put(setCompanyPreferences({
      id: newCustomerPreferences.data.id,
      allowed_suppliers: newCustomerPreferences.data.attributes.allowed_suppliers || [],
      cloud_connect_providers: newCloudProviders.data || [],
      ddos_protection_options: newCustomerPreferences.data.attributes.ddos_protection_options || [],
      manual_crf: newCustomerPreferences.data.attributes.manual_crf || false,
      enforce_monthly_billing: newCustomerPreferences.data.attributes.enforce_monthly_billing || false,
    }));

  } catch (error) {
    // Optionally handle error
  }
}

export default function* rootSaga() {
  yield debounce(300, UserActionTypes.GET_WHOAMI, getWhoAmISaga);
  yield debounce(300, UserActionTypes.UPDATE_UNREAD_COUNTS, updateUnreadCountsSaga);
  yield debounce(300, UserActionTypes.UPDATE_USER_PERSONAL_DETAILS, updateUserSaga);
  yield takeLatest(UserActionTypes.SET_SELECTED_COMPANY, checkCustomerChangeThenFetchCompanyPreferencesSaga);
  yield takeLatest('REFRESH_COMPANY_PREFERENCES', checkCustomerChangeThenFetchCompanyPreferencesSaga);
  yield takeLatest('FORCE_REFRESH_COMPANY_PREFERENCES', fetchCompanyPreferencesSaga);
}
